import React from "react";
import moment from "moment";
import { localize } from "redux-i18n";
import { route } from "@routes/helper";
import { GSGrid } from "@components";
import { COLOR_BY_ACTIVITY_CODE } from "@modules/reporting/constants/reports";

import "./index.scss";

const formatDateToActivityFeed = (date: *, t: *) => {
  if (!date) return "";

  const now = moment();
  const currentDate = moment(date);
  const differenceInMinutes = now.diff(currentDate, "minutes");

  if (differenceInMinutes < 1) {
    return t("N_MINUTES_AGO", { mins: 1 });
  }
  if (differenceInMinutes < 5) {
    return t("N_MINUTES_AGO", { mins: 5 });
  }
  if (differenceInMinutes < 10) {
    return t("N_MINUTES_AGO", { mins: 10 });
  }
  if (differenceInMinutes < 15) {
    return t("N_MINUTES_AGO", { mins: 15 });
  }
  if (differenceInMinutes < 30) {
    return t("N_MINUTES_AGO", { mins: 30 });
  }
  if (differenceInMinutes < 60) {
    return t("N_HOURS_AGO", { hours: 1 });
  }

  return currentDate.format("hh:mm a");
};

const getAllIndexes = (array, value) => {
  const indexes = [];
  const startEndIndexes = [];

  array.forEach((item, index) => {
    if (item === value) {
      indexes.push(index);
    }
  });

  for (let i = 0; i < indexes.length; i += 2) {
    let obj = {};

    obj.start = indexes[i] + 1;
    obj.end = indexes[i + 1];

    startEndIndexes.push(obj);
  }

  return startEndIndexes;
};

const activityFeedDetailsFormatDates = (details: string) => {
  if (!details) return "";

  let activityDescription = details;
  const currentDetailsArray = details.split("");
  const dateStartEndIndexes = getAllIndexes(currentDetailsArray, "#");

  dateStartEndIndexes.forEach(item => {
    const date = details.substring(item.start, item.end);
    const formattedDate = date.includes(".") ? date.split(".")[0] : date;
    const stringToReplace = `#${date}#`;

    activityDescription = activityDescription.replace(
      stringToReplace,
      moment(`${formattedDate}.000Z`).format("DD/MM/YYYY HH:mm"),
    );
  });

  return <div className="ellipsis">{activityDescription}</div>;
};

type OwnProps = $Exact<{
  clientId: ?number,
  tableData: *,
  push: typeof push,
  openRtwInterviewModal: (data: ?Object) => typeof actionCreators.ToggleRtwInterviewModal,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

const DashboardActivityFeedTable = ({ tableData, clientId, t }: Props) => {
  return (
    <GSGrid
      rowKeyGetter={row => `${row.absenceId.id}-${row.employeeId.id}-${row.activityDate}`}
      id="dashboard-activity-feed-table"
      columns={[
        {
          name: t("TYPE"),
          key: "type",
          width: 50,
          renderCell: ({ row }: *) => (
            <div
              className={`activity-feed-mark color-${COLOR_BY_ACTIVITY_CODE[row.activityCode]}`}
            ></div>
          ),
        },
        {
          name: t("WHEN"),
          align: "left",

          width: "auto",
          renderCell: ({ row }: *) => {
            return formatDateToActivityFeed(row.activityDate, t);
          },
        },
        {
          name: t("ACTIVITY"),
          key: "activityType",

          align: "left",
          tooltip: ({ row }: Object) => row.activityType,
        },
        {
          name: t("DETAILS"),

          key: "activityDetails",
          align: "left",
          tooltip: ({ row }: Object) => activityFeedDetailsFormatDates(row.activityDetails),
          renderCell: ({ row }: *) => {
            return activityFeedDetailsFormatDates(row.activityDetails);
          },
        },
        {
          name: t("VIEW"),
          key: "view",
          width: 50,
          frozen: "right",
          align: "center",
          renderCell: ({ row }: *) => {
            return (
              <a
                href={`${route("REPORTING_EMPLOYEE_ABSENCE_DETAILS_PATH", {
                  clientId,
                  employeeId: row.employeeId.id,
                  absenceId: row.absenceId.id,
                })}`}
                target="_blank"
                className="pointer text-decoration-none d-flex"
                rel="noreferrer"
              >
                <span className="material-icons font-size-30 pointer">play_circle</span>
              </a>
            );
          },
        },
      ]}
      rows={tableData}
      noResultsText={t("NO_ACTIVITY_DATA")}
    />
  );
};

export default localize()(DashboardActivityFeedTable);
